import { render } from "./ProjectCommentsContent.vue?vue&type=template&id=0a58d664"
import script from "./ProjectCommentsContent.vue?vue&type=script&lang=js"
export * from "./ProjectCommentsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__